class PlacementChecklist {
    id = 0;
    placement_id = null;
    additional_info = '';
    pulled_time = null;

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default PlacementChecklist;
